(function () {
  const __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.freeSampleButton = this.form.querySelector(
        '.variant-free-sample-button',
      );
      this.cartButton = document.querySelector('[data-cart="button"]');
      this.cartCount = document.querySelector('[data-cart="count"]');
      this.cartWording = document.querySelector('[data-cart="wording"]');
      this.variantId = this.dataset.variantId;
      this.inventory = this.dataset.inventory;
      this.evenPacks = this.dataset.evenPacks;
      this.cartType = this.dataset.cartType;
      this.outOfStockMessage = this.dataset.outOfStockMessage || "We currently only have ${adjustedInventory} packs in stock.";

      this.submitButton = this.querySelector('[type="submit"]');
      this.quantityFieldInput = document.querySelector('product-quantity-input');

      this.cartNotification = document.querySelector('cart-notification');
      this.cart = document.querySelector('cart-drawer');
      this.cartNotificationNew = document.querySelector('#cartNotificationNew');

      this.freeSampleButton !== null
        ? this.freeSampleButton.addEventListener(
            'click',
            this.checkFreeSample.bind(this),
          )
        : null;

      // this.initProductFormData();
    }

    showCartDrawer() {
      this.cart?.show();
    }

    initProductFormData() {
      this.productFormData = window.productFormData || {};
      const productFormData = this.productFormData;

      // console.log(this.productFormData);
      this.defaultOneSqMeterVarId =
        productFormData.oneSqMeter.defaultVarId || '';
      if (productFormData.oneSqMeter.customRules) {
        try {
          this.oneSqMeterCustomRules = JSON.parse(
            productFormData.oneSqMeter.customRules,
          );
        } catch (e) {
          console.log(e);
        }
      }
    }

    getOneSqMeterVarId() {
      try {
        for (let i = 0; i < this.oneSqMeterCustomRules.length; i++) {
          const rule = this.oneSqMeterCustomRules[i];
          if (
            rule.variantId &&
            productConditionsUtils.checkConditions(
              rule.conditions,
              this.productFormData.product,
              this.productFormData.product.collection_ids,
            )
          ) {
            return rule.variantId;
          }
        }
      } catch (e) {
        console.log(e);
      }

      return this.defaultOneSqMeterVarId;
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      const url = '/cart/add.js';
      const variantId = Number(this.variantId);
      const quantityField = document.querySelector('product-quantity-input')
        .dataset.units;

      /* if (quantityField === '1sqm') {
        this.addOneSquareMetre(submitButton, url, variantId);
      } else {
        this.standardProductSetup(
          quantityField,
          submitButton,
          url,
          variantId,
        );
      } */

      this.standardProductSetup(
        quantityField,
        submitButton,
        url,
        variantId,
      );
    }

    showLoading(submitButton) {
      if(submitButton) {
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      }
      this.querySelector('.loading-overlay__spinner').classList.remove(
        'hidden',
      );
    }

    hideLoading(submitButton) {
      if(submitButton) {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
      }
      this.querySelector('.loading-overlay__spinner').classList.add(
        'hidden',
      );
    }

    checkReadyToAdd(submitButton, quantityValue) {
      const quantity = Number(quantityValue);
      if (submitButton.classList.contains('loading')) {
        return false
      };

      if (submitButton.dataset.accessoryRestriction == 'true') {
        this.querySelector('[type="submit"]').disabled = true;
        return false;
      }
      if (quantity < 1) {
        return false
      };

      this.handleErrorMessage();
      this.showLoading(submitButton);

      return true;
    }

    getShopifyCart() {
      return fetch(window.Shopify.routes.root + 'cart.js', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then((response) => {
          return response.json();
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }

    async standardProductSetup(quantityField, submitButton, url, variantId) {
      const quantity = Number(quantityField);
      if(!this.checkReadyToAdd(submitButton, quantityField)) {
        return;
      }
      const properties = {};
      if (this.quantityFieldInput && this.quantityFieldInput.dataset.packSize) {
        properties['_packSize'] = this.quantityFieldInput.dataset.packSize;
      }

      const item = {
        id: variantId,
        quantity: quantity,
        properties: properties,
      };

      const formData = {
        items: [item],
      };

      this.submitATC(url, formData, submitButton);
    }

    async addOneSquareMetre(submitButton, url, variantId) {
      if(!this.checkReadyToAdd(submitButton, 1)) {
        return;
      }
      const addingQty = Number(
        document.querySelector('product-quantity-input').dataset.price,
      );
      const addingId = this.getOneSqMeterVarId();
      const shopifyCart = await this.getShopifyCart();
      if (shopifyCart && shopifyCart.items) {
        if (shopifyCart.items.some((item) => item.id == addingId)) {
          this.showCartDrawer();
          this.hideLoading(submitButton);
          return;
        }
      }

      const addingProp = document.querySelector('product-quantity-input')
        .dataset.productTitle;
      const addingVariant = document.querySelector('product-quantity-input')
        .dataset.variantTitle;

      const addingUnit = 'm2';

      const properties = {
        'Main Product': addingProp,
        'Product Variant': addingVariant,
        '_mainProductUrl': window.location.pathname,
        'Product Unit': addingUnit,
      }

      if(this.dataset.featuredImage) {
        properties['_mainProductImage'] = this.dataset.featuredImage
      }

      const item = {
        quantity: addingQty,
        id: addingId,
        properties: properties,
      };
      const formData = {
        items: [item],
      };

      this.submitATC(url, formData, submitButton);
    }

    isEven(n) {
      // Check if number is even

      return n % 2 == 0;
    }

    async submitATC(url, formData, submitButton) {
      const formElement = this.querySelector('form[action*="/cart/add"]');
      document.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));

      submitButton.setAttribute("aria-busy", "true");
      document.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
       let sectionsToBundle = [];
      document.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...formData,
          sections: sectionsToBundle.join(","),
          sections_url: `${Shopify.routes.root}variants/${formElement.id?.value}`
        }),
      });
      submitButton.removeAttribute("aria-busy");
      const responseJson = await response.json();
      document.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));

      if (response.ok) {
        if (window.themeVariables.settings.cartType === "page" || window.themeVariables.settings.pageType === "cart") {
          return window.location.href = `${Shopify.routes.root}cart`;
        }
        const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
        cartContent["sections"] = responseJson["sections"];
        formElement.dispatchEvent(new CustomEvent("variant:add",{
          bubbles: !0,
          detail: {
              items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson],
              cart: cartContent,
          }
        }));
        document.dispatchEvent(new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "variant:add",
            cart: cartContent
          }
        }));
      } else {
        formElement.dispatchEvent(new CustomEvent("cart:error", {
          bubbles: true,
          detail: {
            error: responseJson["description"]
          }
        }));
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      }

      document.dispatchEvent(new CustomEvent("theme:loading:end"));
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('aria-disabled');
      this.querySelector('.loading-overlay__spinner').classList.add(
        'hidden',
      );
    }

    objectToFormData(obj, form, namespace) {
      const formData = form || new FormData();

      for (let key in obj) {
        if (obj.hasOwnProperty(key)) {
          const formKey = namespace ? `${namespace}[${key}]` : key;

          if (typeof obj[key] === 'object' && !(obj[key] instanceof File)) {
            // If the property is an object (and not a File), recursively call the function
            this.objectToFormData(obj[key], formData, formKey);
          } else {
            // If the property is a primitive type or a File, append it to the FormData
            formData.append(formKey, obj[key]);
          }
        }
      }

      return formData;
    }

    cartNotificationModal() {
      this.cartNotificationNew.classList.remove('cart-notification-new-none');
      this.cartNotificationNew.classList.add(
        'cart-notification-new-outer-container',
      );

      const cartNotificationTitle = document.getElementById(
        'cartNotification-productTitle',
      );
      const productQuantityInput = document.querySelector(
        'product-quantity-input',
      );
      if (cartNotificationTitle) {
        cartNotificationTitle.textContent =
          productQuantityInput.dataset.variantTitle !== 'Default Title'
            ? productQuantityInput.dataset.variantTitle
            : productQuantityInput.dataset.productTitle;
      }

      const cartTitleEl = document.querySelector(
        '.cart-notification-new-inner-container-heading',
      );
      if (cartTitleEl) {
        cartTitleEl.textContent = 'Item added to cart!';
      }
    }

    //   async GTM(formData) {
    // 	const variantId = formData.items[0].id;
    // 	const cartItems = await this.getCart();
    // 	const addedElement = cartItems.find(e => e.variant_id === variantId);
    // 	const productName = addedElement.title;
    // 	const productId = addedElement.product_id;
    // 	const productPrice = (addedElement.price)/100;
    // 	const currency = "GBP";
    // 	const productBrand = addedElement.vendor;

    // 	window.dataLayer = window.dataLayer || [];
    // 	this.gtag('js', new Date());
    // 	this.gtag('config', 'G-FVJV9Z9VMK');

    // 	this.gtag("event", "add_to_cart", {
    // 		currency: currency,
    // 		totalValue: productPrice,
    // 		items: [
    // 			{
    // 				item_id: productId,
    // 				item_name: productName,
    // 				price: productPrice,
    // 				item_brand: productBrand
    // 			}
    // 		]
    // 	});
    //   }

    //   gtag() {
    // 	  dataLayer.push(arguments)
    //   }

    async viewUpsell() {
      const productUpsells = this.querySelector('#product-upsells');
      if (productUpsells) {
        productUpsells.classList.add('is-active');
      }
    }

    async updateCartIcon() {
      const cartProducts = await this.getCart();
      const quantityArray = [];
      for (let index = 0; index < cartProducts.length; index++) {
        const quantity = cartProducts[index].quantity;
        quantityArray.push(quantity);
      }
      const numberOfProducts = cartProducts.length;
      this.cartButton.classList.add('site-header__cart--has-items'),
        (this.cartCount.textContent = numberOfProducts),
        Number(numberOfProducts) > 1
          ? (this.cartWording.textContent = 'items')
          : (this.cartWording.textContent = 'item');
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper =
        this.errorMessageWrapper ||
        this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage =
        this.errorMessage ||
        this.errorMessageWrapper.querySelector(
          '.product-form__error-message',
        );

      if (errorMessage) {
        this.errorMessageWrapper.removeAttribute('hidden');
        this.errorMessage.textContent = errorMessage;
      } else {
        this.errorMessageWrapper.setAttribute('hidden', '');
      }
    }

    async checkFreeSample(evt) {
      if (this.freeSampleButton.dataset.accessoryRestriction == 'true') {
        return;
      }
      const freeSampleVariantId = Number(
        this.freeSampleButton.dataset.variantid,
      );
      const cartProducts = await this.getCart();
      const cartCheck = [];
      const freeSampleInCart = [];
      for (let index = 0; index < cartProducts.length; index++) {
        const element = cartProducts[index];
        const ID = element.variant_id;

        const price = element.price;
        const productTitle = element.variant_title;

        if (price === 0 && productTitle.includes('Sample')) {
          freeSampleInCart.push(true);
        } else if (price === 0 && productTitle.includes('sample')) {
          freeSampleInCart.push(true);
        }

        if (ID === freeSampleVariantId) {
          cartCheck.push(true);
        }
      }

      if (freeSampleInCart.length > 2) {
        alert('You cannot have more than 3 samples in your cart');
      } else if (cartCheck.length !== 0) {
        alert('Free Sample already in cart');
      } else {
        this.addFreeSample(freeSampleVariantId);
      }
    }

    async addFreeSample(freeSampleVariantId) {
      const formData = {
        updates: {
          [freeSampleVariantId]: 1,
        },
      };

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
        .then(async (response) => {
          const res = response.ok;

          if (res === true) {
            this.freeSampleButton.innerHTML = 'Sample Added!';
            this.updateCartIcon();
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }

    async getCart() {
      return new Promise((resolve) => {
        fetch('/cart.js')
          .then((response) => response.json())
          .then((data) => {
            resolve(data.items);
          })
          .catch((err) => console.log('error = ', err));
      });
    }
  }

  class ProductFormAdvance extends ProductForm {
    /**
     * Use shopify function
     * @param {*} submitButton
     * @param {*} url
     * @param {*} variantId
     */
    async addOneSquareMetre(submitButton, url, variantId) {
      if(!this.checkReadyToAdd(submitButton, 1)) {
        return;
      }
      const productQuantityInputEl = document.querySelector('product-quantity-input');
      const addingQty = 1;
      const productUnitPrice = Number(productQuantityInputEl.dataset.pricePerMetresSquared);
      const addingId = variantId;
      const addingProp = productQuantityInputEl.dataset.productTitle;
      const addingVariant = productQuantityInputEl.dataset.variantTitle;
      const addingUnit = 'm2';

      const shopifyCart = await this.getShopifyCart();
      if (shopifyCart && shopifyCart.items) {
        if (shopifyCart.items.some((item) => item.id == addingId && item.properties._isOneSqMeterItem)) {
          this.showCartDrawer();
          this.hideLoading(submitButton);
          return;
        }
      }

      const properties = {
        'Main Product': addingProp,
        'Product Variant': addingVariant,
        '_mainProductUrl': window.location.pathname,
        '_isOneSqMeterItem': true,
        '_productUnitPrice': productUnitPrice,
        'Product Unit': addingUnit,
      }

      if(this.dataset.featuredImage) {
        properties['_mainProductImage'] = this.dataset.featuredImage
      }

      const item = {
        quantity: addingQty,
        id: addingId,
        properties: properties,
      };
      const formData = {
        items: [item],
      };

      if (this.cartType == 'drawer') {
        this.submitATCWithCartDrawer(formData, submitButton);
      } else {
        this.submitATC(url, formData, submitButton);
      }
    }
  }

  customElements.define(
    'product-form-advance',
    ProductFormAdvance,
  );
})();
